import Body from "@ds/elements/text/Body";
import Headline from "@ds/elements/text/Headline";
import Logo from "@ds/identity/logos/Logo";
import React from "react";
import * as styles from "./WelcomeBack.module.css";

export function WelcomeBack() {
    return (
        <section className={styles.root} aria-label="Welcome back to Oplane">
            <div className={styles.topGroup}>
                <header className={styles.brand}>
                    <Logo color="on-surface" height={44} />
                </header>

                <div className={styles.content}>
                    <div className={styles.title}>
                        <Headline scale="large" color="on-surface">
                            Welcome back
                        </Headline>
                    </div>
                    <Body scale="large" color="on-surface">
                        Pick up right where you left off — your threat models,
                        pull-request reviews and security posture, exactly as you
                        parked them.
                    </Body>
                </div>
            </div>
        </section>
    );
}

export default WelcomeBack;
